import _defineProperty from "@babel/runtime/helpers/defineProperty";
import ky from 'ky-universal';
import { makeAPIError, parseError } from "../utils";
import stargateMarketplaceMethods from "./stargate.marketplace";
import { StargateAPIErrorCode } from "./stargate.types";
export default class StargateAPI {
  constructor(baseUrl) {
    _defineProperty(this, "_api", void 0);

    _defineProperty(this, "marketplace", stargateMarketplaceMethods(this));

    this._api = ky.create({
      prefixUrl: baseUrl
    });
  }
  /**
   * Get available sites for the logged in Atlassian Account session
   * @throws {StargateAPIError}
   */


  async availableSites(products) {
    try {
      return await this._api.post('available-sites', {
        json: {
          products
        }
      }).json();
    } catch (error) {
      const {
        status,
        response
      } = await parseError(error);
      throw makeAPIError({
        name: 'AvailableSitesError',
        code: status === 401 ? StargateAPIErrorCode.UNAUTHORIZED : StargateAPIErrorCode.UNKNOWN,
        response
      });
    }
  }
  /**
   * Get whether a user has a permission for a particular resource
   * @throws {StargateAPIError}
   */


  async permitted(permissionId, resourceId) {
    try {
      return await this._api.post('permissions/permitted', {
        json: {
          permissionId,
          resourceId
        }
      }).json();
    } catch (error) {
      const {
        status,
        response
      } = await parseError(error);
      throw makeAPIError({
        name: 'PermittedError',
        code: status === 401 ? StargateAPIErrorCode.UNAUTHORIZED : StargateAPIErrorCode.UNKNOWN,
        response
      });
    }
  }

}